module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "searchBox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchText),
      expression: "searchText"
    }],
    staticClass: "txt",
    attrs: {
      "type": "text",
      "placeholder": "曲目、歌手搜索"
    },
    domProps: {
      "value": (_vm.searchText)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.searchSong($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchText = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "search",
    class: {
      search2: _vm.searchFlag == 1
    },
    on: {
      "click": _vm.searchSong
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e41742f0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/header.vue
// module id = 109
// module chunks = 0